import { EMoneySource } from '../../../../../types/reducers/user';

export const getOptionDataName = (source: EMoneySource) => {
  return `MoneySource${source.charAt(0).toUpperCase() + source.slice(1)}`;
};
